// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__PgVDS","image":"styles_image__1isYP","words":"styles_words__2OU3g","placeholder":"styles_placeholder__3QpvL"};